"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolicyTermSelectInput = exports.usePolicyTermOptions = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importStar(require("react"));
var policy_terms_1 = require("../../hooks/policy-terms");
function usePolicyTermOptions() {
    var data = (0, policy_terms_1.usePolicyTerms)().data;
    var policyTermOptions = (0, react_1.useMemo)(function () {
        var options = (data === null || data === void 0 ? void 0 : data.policyTerms.map(function (policyTerm) { return ({
            label: policyTerm,
            value: policyTerm,
        }); })) || [];
        return options;
    }, [data === null || data === void 0 ? void 0 : data.policyTerms]);
    return policyTermOptions;
}
exports.usePolicyTermOptions = usePolicyTermOptions;
function PolicyTermSelectInput(props) {
    var onChange = props.onChange, value = props.value, disabled = props.disabled, name = props.name, innerRef = props.innerRef, testId = props.testId;
    var policyTermOptions = usePolicyTermOptions();
    return (react_1.default.createElement(core_ui_1.SelectInput, { name: name, options: policyTermOptions, onChange: function (nextValue) { return onChange(nextValue); }, value: value, innerRef: innerRef, disabled: disabled, testId: testId, showSelectAnOption: true }));
}
exports.PolicyTermSelectInput = PolicyTermSelectInput;
